import { TemplatePage } from './types';

const podcastPromotionPage: TemplatePage = {
  header: {
    color: '#FEF16E',
    icon: 'images/video-templates/podcast-promotion.jpg',
    title: 'Podcast Promotion Video Templates',
    title_meta: '100+ Customizable Podcast Promotional Video Templates',
    description_meta:
      'Leverage video content to promote your podcast. Get more subscribers to your episodes with over 100 ' +
      'customizable video templates.',
    description:
      'Made for professional and novice podcasters, these video templates are your shortcut to growing your ' +
      'audience. Promote your future episodes and share the insights when the mic is off. Pick a video template ' +
      'you like and easily customize it with your branding.'
  },
  footer: {
    category: 'Podcast Promotion',
    description:
      'Wave.video offers a collection of podcast promotion video templates. Regardless of the industry or niche, ' +
      'you’ll definitely find video templates that meet your needs for instant video production. Make great ' +
      'promotional videos from templates that are easily customizable and feature great eye-catching details such ' +
      'as captions, waveforms, text animation effects and graphics. <br> Once the video is ready, share it across ' +
      'various social media channels, embed on your web pages and emails, or turn them into video landing pages. ' +
      'With Wave.video, you can do it all in one place.'
  },
  content: [
    {
      type: 'templates',
      title: 'Podcast Promotion Videos',
      search: { category: '/Use Cases/Podcast Promotion' }
    },
    {
      type: 'stocks',
      title: 'podcast promotion',
      search: { name: 'podcast' }
    },
    { type: 'calendar' }
  ]
};

export default podcastPromotionPage;
